<template>
  <section class="p-7 md:pl-16 lg:pr-12 lg:pl-20 pb-6 mb-component">
    <h2
      v-if="parsedDictionary.title"
      class="text-40 font-medium text-darkGreen tracking-tightest2"
    >
      {{ parsedDictionary.title }}
    </h2>
    <p
      v-if="parsedDictionary.description"
      class="text-18 font-normal text-graphite-8 mt-6 leading-140 tracking-tightest2"
    >
      {{ parsedDictionary.description }}
    </p>

    <div
      v-if="parsedDictionary.steps"
      class="w-full flex max-md:flex-col mt-10"
    >
      <div
        class="flex max-md:flex-col flex-grow"
        v-for="(step, index) in parsedDictionary.steps"
        :key="step.title"
      >
        <div>
          <p
            class="size-[3.375rem] flex items-center justify-center rounded-full border border-border text-center font-normal text-18"
          >
            {{ index + 1 }}
          </p>
          <h3
            class="text-20 mt-8 font-medium text-darkGreen tracking-tightest2 leading-135"
          >
            {{ step.title }}
          </h3>
          <p
            class="text-16 font-normal text-graphite-8 mt-4 leading-140 -tracking-0.5"
          >
            {{ step.description }}
          </p>
        </div>

        <div
          v-if="index !== parsedDictionary.steps.length - 1"
          class="h-full max-md:mb-7 max-md:mt-10 mt-3 md:px-6 lg:px-[2.8125rem] flex items-center justify-center"
        >
          <ArrowRight class="text-darkGreen max-md:rotate-90 size-5" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import ArrowRight from "../../../svg/ArrowRight.vue";

export default {
  name: "HowItWorks",
  data() {
    return {
      parsedDictionary: {},
    };
  },

  props: {
    dictionary: {
      type: String,
      required: true,
    },
  },

  created() {
    this.parsedDictionary = JSON.parse(this.dictionary);
  },

  components: {
    ArrowRight,
  },
};
</script>
